export var Global = {
    // url: 'http://localhost/server_iclock/public/api',
    // url:'http://172.176.145.53/server_iclock/public/api',
    url: 'https://iclockserver.lavoroperu.pe/api',
    info: 'infoClock',
    system: 'iclock',
    infoTime: 'infoExpirationClock',
    path: null,
};